/**
 * WatermillTopicsRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { WatermillTopicInfo } from './watermill_topic_info'

/**
 * WatermillTopicsRes
 */
export interface WatermillTopicsRes {
  topics?: WatermillTopicInfo[]
}

/**
 * WatermillTopicsRes Schema
 */
export const WatermillTopicsResSchema: SchemaDefinition = {
  properties: {
    topics: {
      format: '[]*model.WatermillTopicInfo',
      items: { $ref: 'WatermillTopicInfo', description: '' },
      type: 'array',
    },
  },
  type: 'object',
}
